import _ from 'underscore';
import queryString from 'query-string';
import {
  createRequestContract,
  createResponseContract,

  requestVerbs,
  responseTypes,
} from '@bingads-webui-react/overreact';

import { edm } from '../../../environment/edm';
import { schema } from '../../../environment/schema';
import { parseSearch, getDefaultHeaderObj } from '../../../request-contract-helper';

function odataUrlFactory(params) {
  const { variables } = params;

  const {
    locator,
    pageSize,
    cursorIndex,
    filter = {
      where: "(CampaignType eq Enum.CampaignType'Smart')",
    },
    orderby = {
      Status: 1,
    },
    select,
    count = true,
    startDate,
    endDate,
  } = variables;

  const { descriptor } = locator;
  const { cid, aid } = descriptor;
  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns;
  const search = {
    top: pageSize,
    skip: cursorIndex,
    filter,
    orderby,
    select,
    count,
  };

  const parsedSearch = {
    ...parseSearch(search, entity),
    startdate: startDate,
    enddate: endDate,
    includesmartcampaign: true,
  };

  const searchCompact = _.omit(parsedSearch, x => _.isNull(x) || _.isUndefined(x));
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return `${entity.path}${searchString}`;
}

function odataHeaderFactory() {
  return getDefaultHeaderObj();
}

export const fetchRequestContract = createRequestContract({
  schema,
  dataPath: 'customer:account:campaign',
  verb: requestVerbs.GET,
  uriFactoryFn: odataUrlFactory,
  headerFactoryFn: odataHeaderFactory,
  keySelector: campaign => campaign.Id,
  parentKeySelector: variables => variables.locator.descriptor.aid,
});

export const fetchResponseContract = createResponseContract({
  requestContract: fetchRequestContract,
  responseType: responseTypes.COLL,
  keySelector: campaign => campaign.Id,
  processorFn: response => response.value,
});
